var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/aaronphy/gitlab/lazada/node_modules/_nunjucks-loader@2.4.8@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/module/shortcuts/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-shortcuts shortcuts\">\n  ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "shortcuts");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n    <div class=\"item J_Item shortcuts-item ";
if(runtime.memberLookup((t_4),"isNew")) {
output += "light";
;
}
output += " ";
if(runtime.memberLookup((t_4),"isHighlight")) {
output += "highlight";
;
}
output += "\" data-type=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"type"), env.opts.autoescape);
output += "\" data-text=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "\" data-means=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"content"), env.opts.autoescape);
output += "\" data-code=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"code"), env.opts.autoescape);
output += "\" aria-label=\"快捷短语：";
output += runtime.suppressValue(runtime.memberLookup((t_4),"title"), env.opts.autoescape);
output += "，双击发送\" role=\"button\">\n      <span class=\"outer\" aria-hidden=\"true\"> \n        <span class=\"inner\">\n          ";
if(runtime.memberLookup((t_4),"icon")) {
output += "\n          <svg class=\"icon icon-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"icon"), env.opts.autoescape);
output += "\" aria-hidden=\"true\">\n            <use xlink:href=\"#icon-";
output += runtime.suppressValue(runtime.memberLookup((t_4),"icon"), env.opts.autoescape);
output += "\"></use>\n          </svg>\n          ";
;
}
output += "\n          ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_4),"title")), env.opts.autoescape);
output += "\n          </span>\n      </span>\n      ";
if(runtime.memberLookup((t_4),"isNew")) {
output += "\n      <i class=\"icon-new\"></i>\n      ";
;
}
output += "\n    </div>\n  ";
;
}
}
frame = frame.pop();
output += "\n</div>\n<div class=\"m-shortcut-close\">\n   <span class=\"iconfont icon-close\"></span>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/module/shortcuts/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/module/shortcuts/tpl.html
// module id = 202
// module chunks = 0 1